<template>
  <el-container>
    <el-header>
      <el-page-header title @back="$router.push('/home').catch(() => {})" :content="$t('mensagem')"></el-page-header>
    </el-header>
    <el-main>
      <el-row type="flex" justify="end">
        <el-col :xs="12" :sm="6" :md="6" :lg="3" :xl="3">
          <el-input :placeholder="$t('pesquisar')" prefix-icon="el-icon-search" v-model="filter"></el-input>
        </el-col>
        <el-col :xs="6" :sm="6" :md="6" :lg="3" :xl="3">
          <el-button
            class="right"
            type="warning"
            icon="el-icon-plus"
            @click="go('adicionar')"
          >{{ $t('nova-mensagem') }}</el-button>
        </el-col>
      </el-row>
      <br />
      <el-row type="flex">
        <el-col :xs="6" :sm="6" :md="6" :lg="3" :xl="3">
          <el-button class="right">{{ $t('marcar-como-lida') }}</el-button>
        </el-col>
        <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="50%">
            <el-form-item :label="$t('listar-somente-nao-lidas')" prop="extent">
              <el-switch v-model="ruleForm.delivery"></el-switch>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <br />
      <el-table
        :data="tableData.filter(data => !filter || data.name.toLowerCase().includes(filter.toLowerCase()) || data.companyname.toLowerCase().includes(filter.toLowerCase()) || data.federalid.toLowerCase().includes(filter.toLowerCase()) )"
        ref="tableRoles"
        style="width: 100%"
        :row-class-name="tableRowClassName"
        :default-sort="{prop: 'code', order: 'ascending'}"
      >
        <el-table-column type="selection" width="180"></el-table-column>
        <el-table-column sortable prop="subject" :label="$t('assunto')">
          <template slot-scope="scope">
            <el-link type="primary">{{ scope.row.subject }}</el-link>
          </template>
        </el-table-column>
        <el-table-column prop="timestamp" :label="$t('data')"></el-table-column>
      </el-table>
    </el-main>
  </el-container>
</template>
<script>
//import { UserService } from "@/services/users/user.services";
import { i18n } from "@/plugin/i18n";
import ZipMixins from "../../../mixins/zipcode";

export default {
  name: "TagsGenerate",
  mixins: [ZipMixins],
  methods: {
    go: function (page) {
      var vm = this;
      vm.$router.push(`/servicos/mensagem/${page}`).catch(() => {});
    },
    tableRowClassName({ row, rowIndex }) {
      if (!row.read) {
        return "warning-row";
      }
      return "";
    },
    fetchRecords() {
      /*    const vm = this;
      const loading = vm.$loading({
        lock: true,
        text: i18n.tc("carregando"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      UserService.list()
        .then((response) => {
          vm.tableData = response.records;
        })
        .catch((error) => {
          vm.$notify.error({
            title: i18n.tc("erro"),
            message: error,
          });
        })
        .finally(() => loading.close());*/
    },
  },
  mounted() {
    const vm = this;
    vm.fetchRecords();
  },
  data() {
    return {
      filter: "",
      tableData: [
        {
          subject: "Nova atualização tabela de preço",
          read: false,
          timestamp: "25/07/2020 13:16",
        },
        {
          subject: "Feriado em São Paulo",
          read: true,
          timestamp: "25/07/2020 13:16",
        },
        {
          subject: "Aviso correio",
          read: true,
          timestamp: "25/07/2020 13:16",
        },
        {
          subject: "Serviço SEDEX indisponivel",
          read: false,
          timestamp: "25/07/2020 13:16",
        },
      ],
    };
  },
};
</script>
<style>
.right {
  float: right;
}
.label {
  font-weight: bold;
}
</style>